import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import Typography from '@mui/joy/Typography';

// components
import BaseApi from "../../utils/BaseApi";
import DeliveryTable from "./DeliveryTable";


class DeliveryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveries: [],
        };
    }

    async componentDidMount() {
        await this.retrieveDeliveries();
    }

    async retrieveDeliveries() {
        const url = 'delivery_state/my/';
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                deliveries: response.data.results
            }
        );
    }

    render() {
        if (!this.state.deliveries) {
            return (<CircularProgress/>)
        }
        return (
            <Stack>
                <Typography
                    level="h1"
                    fontSize="xl4"
                    sx={{'pb': 2}}
                >
                    Мои бизнес-процессы
                </Typography>
                <DeliveryTable
                    deliveries={this.state.deliveries}
                    callBack={this.retrieveDeliveries.bind(this)}
                    showAccount={true}
                    showOpportunity={true}
                />
            </Stack>
        )
    }
}

export default DeliveryList;
